<div class="row" *ngIf="!doneLoading; else loading">
  <div class="col-12">
    <h3 translate>APPLICATION_SETTINGS</h3>
  </div>
  <div></div>
</div>
<ng-template #loading>
  <i class="fa fa-spinner fa-spin fa-lg"></i>
</ng-template>
